export default ({ params, errors } = window.FORM_DATA) => {
  const {
    nationalIdFrontPicUploaded = false,
    nationalIdBackPicUploaded = false,
    driverLicencePicUploaded = false,
    vehicleRegistrationFrontPicUploaded = false,
    vehicleRegistrationBackPicUploaded = false,
    vehicleFullViewPicUploaded = false
  } = params

  return {
    errors,
    submitDisabled: false,
    uploadsInProgress: 0,

    // Egypt only
    nationalIdFrontPicUploaded,
    nationalIdBackPicUploaded,
    driverLicencePicUploaded,
    vehicleRegistrationFrontPicUploaded,
    vehicleRegistrationBackPicUploaded,
    vehicleFullViewPicUploaded,

    form: {
      '@submit' (event) {
        if (this.submitDisabled) {
          event.preventDefault()
        } else {
          this.submitDisabled = true
        }
      },

      '@upload:start' () {
        this.uploadsInProgress++
        this.submitDisabled = this.uploadsInProgress > 0
      },

      '@upload:finish' () {
        this.uploadsInProgress--
        this.submitDisabled = this.uploadsInProgress > 0
      }
    }
  }
}
